<template>
  <main class="story-shell" :class="{ 'story-shell--theater': theaterActive }">
    <div v-show="theaterActive" class="story-theater-heading" aria-hidden="true">
      <strong>{{ theaterConcept }}</strong>
    </div>
    <iframe ref="storyFrame" class="story-frame" :src="storySource" title="라피아 공주 이야기" allow="fullscreen" @load="observeTheater"></iframe>
    <v-btn v-show="isDetail && !theaterActive" fixed bottom right color="primary" large class="story-reserve-btn" rounded elevation="6" @click="goReserve">
      <v-icon left>mdi-calendar-check</v-icon>
      {{ $t("button.do-reserve") }}
    </v-btn>
  </main>
</template>

<script>
export default {
  data() {
    return {
      theaterActive: false,
      theaterLabel: "",
      theaterObserver: null,
      pageOverflow: "",
      bodyOverflow: "",
    }
  },
  computed: {
    storyLang() {
      const lang = this.$store && this.$store.state ? this.$store.state.lang : "ko"
      return ["ko", "en", "jp"].includes(lang) ? lang : "ko"
    },
    isDetail() {
      return this.$route.name === "princess-story-detail"
    },
    theaterConcept() {
      return this.$route.query.conceptName || "LAFIA PRINCESS STORY"
    },
    storySource() {
      const params = new URLSearchParams()
      Object.keys(this.$route.query).forEach((key) => {
        const value = this.$route.query[key]
        if (Array.isArray(value)) value.forEach((item) => params.append(key, item))
        else if (value != null) params.set(key, value)
      })
      params.set("embedded", "1")
      params.set("lang", this.storyLang)
      const page = this.$route.name === "princess-story-detail" ? "/mian_00_story_list.html" : "/mian_00_story.html"
      return `${page}?${params.toString()}`
    },
  },
  mounted() {
    window.addEventListener("message", this.handleStoryNavigation)
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleStoryNavigation)
    this.disconnectTheaterObserver()
    this.setTheaterActive(false)
  },
  methods: {
    goReserve() {
      const query = {}
      if (this.$route.query.conceptId) query.conceptId = this.$route.query.conceptId
      if (this.$route.query.event) query.event = this.$route.query.event
      query.lang = this.storyLang
      this.$router.push({ path: "/booking/reserve", query }).catch(() => {})
    },
    handleStoryNavigation(event) {
      if (event.origin !== window.location.origin || event.source !== this.$refs.storyFrame.contentWindow) return
      if (event.data && event.data.type === "lafia-story-open") {
        const query = { ...(event.data.query || {}), lang: this.storyLang }
        this.$router.push({ name: "princess-story-detail", query }).catch(() => {})
      }
      if (event.data && event.data.type === "lafia-story-back") {
        this.$router.replace({ name: "princess-story", query: { lang: this.storyLang } }).catch(() => {})
      }
    },
    observeTheater() {
      this.disconnectTheaterObserver()
      const frame = this.$refs.storyFrame
      const document = frame && frame.contentDocument
      const body = document && document.body
      if (!frame || !document || !body) {
        window.setTimeout(() => {
          if (this.$refs.storyFrame === frame) this.observeTheater()
        }, 60)
        return
      }
      const sync = () => {
        const modal = document.querySelector(".lf4-theater-modal")
        this.theaterLabel = modal ? modal.getAttribute("aria-label") || "" : ""
        this.setTheaterActive(Boolean(modal))
      }
      this.theaterObserver = new MutationObserver(sync)
      this.theaterObserver.observe(body, { childList: true, subtree: true })
      sync()
    },
    disconnectTheaterObserver() {
      if (this.theaterObserver) this.theaterObserver.disconnect()
      this.theaterObserver = null
    },
    setTheaterActive(active) {
      if (this.theaterActive === active) return
      this.theaterActive = active
      if (active) {
        this.pageOverflow = document.documentElement.style.overflow
        this.bodyOverflow = document.body.style.overflow
        document.documentElement.style.overflow = "hidden"
        document.body.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = this.pageOverflow
        document.body.style.overflow = this.bodyOverflow
      }
    },
  },
}
</script>

<style scoped>
.story-shell {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  margin: 0 !important;
  overflow: hidden;
  background: #fff;
}

.story-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.story-shell--theater {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  margin: 0 !important;
  background: #08070a;
}

.story-shell--theater .story-frame {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: #08070a;
}

@font-face {
  font-family: "Cafe24Danjunghae";
  src: url("/fonts/Cafe24Danjunghae-v2.0.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

.story-theater-heading {
  position: fixed;
  top: calc(22px + env(safe-area-inset-top, 0px));
  left: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100vw, 600px);
  height: 46px;
  padding: 0 76px;
  color: #fff;
  transform: translateX(-50%);
  pointer-events: none;
}

.story-theater-heading strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.story-theater-heading strong {
  width: 100%;
  color: #fff8fb;
  font-family: "Cafe24Danjunghae", serif;
  font-size: 29px;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  text-shadow: 0 0 20px rgba(231, 154, 185, 0.18);
}

@media (max-width: 520px) {
  .story-theater-heading {
    top: calc(20px + env(safe-area-inset-top, 0px));
    height: 46px;
    padding: 0 68px;
  }

  .story-theater-heading strong {
    width: 100%;
    font-size: 27px;
  }
}

.story-reserve-btn {
  z-index: 12;
}
</style>
